import { createContext, useEffect, useReducer } from "react";
import { getProviders, getHomePage, getFaqsPage, getTeamPage, getCommunityPage, getResourcesPage, getContactPage, getCommunityEvents } from "../sanity/client";

const initialState = {
  val1: "val1",
  siteData: null,

};
const AppContext = createContext({
  ...initialState,
});

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    appReducer,
    initialState,
  );

  useEffect(() => {
    Promise.all([
      getProviders(),
      getHomePage(),
      getTeamPage(),
      getCommunityPage(),
      getFaqsPage(),
      getResourcesPage(),
      getContactPage(),
      getCommunityEvents(),
    ]).then(([providers, homePage, teamPage, communityPage, faqsPage, resourcesPage, contactPage, communityEvents]) => {
      setSiteData({
        providers: providers,
        homePage: homePage,
        teamPage: teamPage,
        communityPage: communityPage,
        faqsPage: faqsPage,
        resourcesPage: resourcesPage,
        contactPage: contactPage,
        communityEvents: communityEvents,
      });
    })
    // const fetchSiteData = async () => {

  }, []);


  const setSiteData = (newVal) => {
    dispatch({
      type: "SET_SITEDATA",
      to: newVal,
    });
  }

  return (
    <AppContext.Provider
      value={{
        siteData: state.siteData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const appReducer = (state, action) => { 
  switch (action.type) {
    case "SET_SITEDATA":
      return {
        ...state,
        siteData: action.to,
      };
    
    default:
      throw new Error();
  }
};

export { AppProvider };


export default AppContext;
